import Logger from '../logger';
import event from '../mixins/event';
import KeenSlider from 'keen-slider'

class TestimonialsCarousel {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'TestimonialsCarousel';

		this.dom = dom;

		this.carousel = null;
		this.sliderDom = this.dom.querySelector(`[data-testimonials-carousel-slides]`);
		this.slidesDoms = this.dom.querySelectorAll(`[data-testimonials-carousel-slide]`);
		this.activeSlideClass = `testimonials-carousel__slide--active`;

		this.prevButtonDom = this.dom.querySelector(`[data-testimonials-carousel-prev]`);
		this.nextButtonDom = this.dom.querySelector(`[data-testimonials-carousel-next]`);

		this.counterDom = this.dom.querySelector(`[data-testimonials-carousel-counter]`);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);

		this.initCarousel();
	}

	/**
	 * initCarousel - Initialize the carousel
	 */
	initCarousel() {
		Logger.info(`${this.NAME} > initCarousel`);

		if (this.carousel) return;

		if (!this.sliderDom) return;

		const self = this;

		this.carousel = new KeenSlider(this.sliderDom, {
			selector: `[data-testimonials-carousel-slide]`, // Required
			loop: true,
			slides: {
				perView: 1
			},
			created: self.updateCarouselClasses.bind(this),
			slideChanged: self.updateCarouselClasses.bind(this),
		});

		this.prevButtonDom?.addEventListener('click', () => this.carousel.prev());
		this.nextButtonDom?.addEventListener('click', () => this.carousel.next());
	}

	/**
	 * updateCarouselClasses - Update the carousel classes
	 */
	updateCarouselClasses(slider) {
		Logger.info(`${this.NAME} > updateCarouselClasses`);

		if (!slider) return;

		const idx = slider.track.details.rel;

		this.counterDom.innerHTML = `${idx + 1}`;

		this.slidesDoms?.forEach((slide, index) => {
			if (index === idx) {
				slide.classList.add(this.activeSlideClass);
			} else {
				slide.classList.remove(this.activeSlideClass);
			}
		});



	}

}

Object.assign(TestimonialsCarousel.prototype, event);

export default TestimonialsCarousel;
